import { Flame, Clock, Snowflake } from "lucide-react";

export const INTEREST = {
  hot: { label: "Hot", icon: Flame, cls: "bg-mint/15 text-mint", bar: "bg-mint", desc: "Siap membeli, follow up sekarang" },
  medium: { label: "Medium", icon: Clock, cls: "bg-amber/15 text-amber", bar: "bg-amber", desc: "Tertarik tapi masih mempertimbangkan" },
  cold: { label: "Cold", icon: Snowflake, cls: "bg-slate/20 text-paper", bar: "bg-slate", desc: "Hanya lihat-lihat" },
};

export function InterestBadge({ level, testId }) {
  const cfg = INTEREST[level];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <span data-testid={testId || `interest-badge-${level}`}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${cfg.cls}`}>
      <Icon size={11} /> {cfg.label}
    </span>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-medium text-muted">{label}</span>
      {children}
    </label>
  );
}

export const inputCls =
  "w-full rounded-xl border border-white/10 bg-ink px-3.5 py-2.5 text-sm text-paper placeholder:text-faint focus:border-mint/50 focus:outline-none";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-paper px-5 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-white disabled:opacity-50";

export const btnMint =
  "inline-flex items-center justify-center gap-2 rounded-full bg-mint px-5 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-mint/85 disabled:opacity-50";

export const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-muted transition-colors hover:text-paper hover:border-white/25 disabled:opacity-50";
